// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../svg/arrowDown.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --color-light: #f4f9ff;
  --color-white: #ffffff;
  --color-white-2: #fbfcfe;
  --color-primary: #1f68d6;
  --color-primary-2: #3b7ee3;
  --color-primary-3: #ccedff;
  --color-primary-4: #003c97;
  --color-primary-7: #c1daff;
  --color-primary-8: #97c1ff;
  --color-primary-09: #ccedff;
  --color-mima-light: #eef2f5;
  --color-error: #e12f2f;
  --color-success: #66b032;
  --color-green: #569755;
  --color-green-2: #92e391;
  --color-green-3: #d3eace;
  --color-yellow: #e7d788;
  --color-yellow-2: #ffaa00;
  --color-yellow-3: #8f4f00;
  --color-light-red: #f7d1cd;
  --color-deep-red: #9f0000;
  --color-grey: #b3b3c5;
  --color-grey-2: #d1d1d1;
  --color-grey-3: #e0e9f3;
  --color-grey-4: #f9f9fa;
  --color-grey-5: #ebebf5;
  --color-grey-6: #eaecef;
  --color-grey-7: #fafafa;
  --color-grey-8: #707a8a;
  --color-table-grey: #fafafc;
  --color-table-grey-1: #f4f4fc;
  --color-dark: #252624;
  --color-dark-2: #1a1a42;
  --color-dark-3: #696365;
  --color-dark-6: #2a2828;
  --color-disabled: #c0c0c0;
  --color-light-blue: #ebf2ff;
  --color-light-blue-2: #d4e5ff;
  --color-light-blue-3: #e7f3fe;
  --color-dark-yellow: #7e6e1f;
  --color-light-brown: #f4f5f6;
  --color-light-green: #e4ffec;
  --color-light-yellow: #fff5d7;
  --color-light-red: #ffe8e8;
  --color-light-grey: #f3f3ff;
  --color-admin: #112855;
  --color-admin-2: #071530;
  --color-admin-3: #020710;
  --color-fash-primary: #f5cc16;
  --color-fash-primary-2: #c4a108;
  --color-fash-primary-3: #927700;
  --color-fash-primary-4: #f5e8b0;
  --color-fash-black: #0c090d;
  --color-fash-black-2: #312d33;
  --color-purple: #6a3c8f;
  --color-purple-1: #430d6e;
  --color-fash-green: #cbebca;
  --color-fash-green-1: #ebf2e9;
  --color-fash-green-2: #035e00;
  --color-fash-green-3: #023300;
  --color-fash-wine: #824670;
  --color-moneyex-primary: #25c900;
  --color-moneyex-primary-2: #6bf04d;
  --color-moneyex-primary-3: #305627;
  --color-moneyex-primary-4: #0a2404;
  --default-font-size: 1.8rem;
  --default-font-h1: 6.4rem;
  --default-font-h2: 4rem;
  --default-font-h3: 3.2rem;
  --default-font-subtitle: 2.4rem;
  --default-font-small: 1.4rem;
  --default-font-xsmall: 1.2rem;
  --primary-font: "Montserrat", -apple-system, BlinkMacSystemFont, "Segoe UI",
    "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans",
    "Helvetica Neue", sans-serif;
  --secondary-font: "Rowdies", "Segoe UI", "Roboto", "Oxygen", "Ubuntu",
    "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif;
  --tertiary-font: "Rubik", "Segoe UI", "Roboto", "Oxygen", "Ubuntu",
    "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif;
}

.MimaDropdown_label__Xurff {
  font-size: 1.4rem;
  font-family: inherit;
  padding-left: 2rem;
  margin-bottom: 1rem;
  width: 100%;
  display: flex;
  max-width: 38rem;
}
.MimaDropdown_label__wide__72MNG {
  font-size: 1.4rem;
  font-family: inherit;
  padding-left: 2rem;
  margin-bottom: 1rem;
  padding-left: 2rem;
}

.MimaDropdown_select__dhfeg {
  display: flex;
  width: 100%;
  flex-direction: column;
  margin-top: 3rem;
  color: #4a4a68;
}
.MimaDropdown_select__options__xLi7K {
  padding: 1.5rem 2rem;
  cursor: pointer;
}
.MimaDropdown_select__options__xLi7K:hover {
  background-color: var(--color-dark);
  color: var(--color-white);
}
.MimaDropdown_select__options_selected__1Ic9v {
  padding-left: 2rem;
  padding-top: 1.9rem;
  width: 38rem;
  height: 6rem;
  border-radius: 1rem;
  background-color: var(--color-white);
  border: 1px solid #4a4a68;
  display: block;
  justify-content: center;
  box-sizing: border-box;
  cursor: pointer;
  color: #4a4a68;
  margin-top: 0.5rem;
  margin-bottom: 1rem;
  order: 0;
  position: relative;
}
.MimaDropdown_select__options_selected__1Ic9v::after {
  content: "";
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: contain;
  background-repeat: no-repeat;
  position: absolute;
  height: 100%;
  width: 1.6rem;
  right: 2rem;
  top: 2.5rem;
  transition: all 0.4s;
}
.MimaDropdown_select__options_selected__wide__uJhGk {
  padding-left: 2rem;
  width: 100%;
}
.MimaDropdown_select__options_active__bNzTz + .MimaDropdown_select__options_selected__1Ic9v::after {
  transform: rotateX(180deg);
  top: -2.5rem;
}
.MimaDropdown_select__options_container__KYLP5 {
  background-color: var(--color-white);
  color: #4a4a68;
  border: 1px solid #4a4a68;
  width: 38rem;
  border-radius: 1rem;
  transition: all 0.4s;
  order: 1;
  max-height: 27rem;
  overflow-y: scroll;
}
.MimaDropdown_select__options_container__KYLP5::-webkit-scrollbar {
  width: 1rem;
  background-color: var(--color-white);
  border-radius: 0 1rem 1rem 0;
}
.MimaDropdown_select__options_container__KYLP5::-webkit-scrollbar-thumb {
  background-color: #b3b3c5;
  border-radius: 1rem;
}
.MimaDropdown_select__options_container__wide__DveW- {
  width: 60rem;
}
@media only screen and (max-width: 31.25em) {
  .MimaDropdown_select__options_container__wide__DveW- {
    width: 38rem;
  }
}
.MimaDropdown_select__options_active__bNzTz {
  opacity: 1;
  max-height: 27rem;
  overflow-y: scroll;
}
.MimaDropdown_select__options_label__vZRRu {
  cursor: pointer;
}

.MimaDropdown_select2__WC\\+vJ {
  display: flex;
  width: 18rem;
  flex-direction: column;
  margin-top: 3rem;
  color: #4a4a68;
}
.MimaDropdown_select2__options__QYoIu {
  padding: 1.5rem 2rem;
  cursor: pointer;
}
.MimaDropdown_select2__options__QYoIu:hover {
  background-color: var(--color-dark);
  color: var(--color-white);
}
.MimaDropdown_select2__options_selected__TI9ZR {
  padding-left: 2rem;
  padding-top: 0.9rem;
  font-size: var(--default-font-small);
  width: 18rem;
  height: 4rem;
  border-radius: 1rem;
  background-color: var(--color-white);
  border: 1px solid #4a4a68;
  display: block;
  justify-content: center;
  box-sizing: border-box;
  cursor: pointer;
  color: #4a4a68;
  margin-top: 0.5rem;
  order: 0;
  position: relative;
}
.MimaDropdown_select2__options_selected__TI9ZR::after {
  content: "";
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: contain;
  background-repeat: no-repeat;
  position: absolute;
  height: 100%;
  width: 1.6rem;
  right: 2rem;
  top: 1.5rem;
  transition: all 0.4s;
}
.MimaDropdown_select2__options_selected__wide__2eROH {
  padding-left: 2rem;
  width: 100%;
}
.MimaDropdown_select2__options_active__jr8lX + .MimaDropdown_select2__options_selected__TI9ZR::after {
  transform: rotateX(180deg);
  top: -2.5rem;
}
.MimaDropdown_select2__options_container__qzUuM {
  background-color: var(--color-white);
  color: #4a4a68;
  border: 1px solid #4a4a68;
  width: 18rem;
  border-radius: 1rem;
  transition: all 0.4s;
  order: 1;
  max-height: 27rem;
  overflow-y: scroll;
  font-size: var(--default-font-small);
}
.MimaDropdown_select2__options_container__qzUuM::-webkit-scrollbar {
  width: 1rem;
  background-color: var(--color-white);
  border-radius: 0 1rem 1rem 0;
}
.MimaDropdown_select2__options_container__qzUuM::-webkit-scrollbar-thumb {
  background-color: #b3b3c5;
  border-radius: 1rem;
}
.MimaDropdown_select2__options_container__wide__-\\+qxN {
  width: 38rem;
}
@media only screen and (max-width: 31.25em) {
  .MimaDropdown_select2__options_container__wide__-\\+qxN {
    width: 18rem;
  }
}
.MimaDropdown_select2__options_active__jr8lX {
  opacity: 1;
  max-height: 27rem;
  overflow-y: scroll;
}
.MimaDropdown_select2__options_label__7f\\+Pg {
  cursor: pointer;
}

.MimaDropdown_filled__9OL8h {
  color: #4a4a68;
}

.MimaDropdown_error__3x5pG {
  font-size: var(--default-font-small);
  color: var(--color-error);
  padding-left: 2rem;
  font-weight: 400;
  margin: 1rem 0;
  max-width: 38rem;
}

.MimaDropdown_success__h3__HAymX {
  color: var(--color-success);
  font-size: var(--default-font-h3);
  font-weight: 700;
  line-height: 3.5rem;
}

.MimaDropdown_tags__yobUM {
  display: flex;
  flex-wrap: wrap;
}
.MimaDropdown_tags__yobUM > :not(:last-child) {
  margin-right: 1rem;
}

.MimaDropdown_singleTag__2cQTo {
  display: flex;
  font-size: var(--default-font-small);
  align-items: center;
  background-color: var(--color-primary-3);
  padding: 0.5rem;
  border-radius: 0.5rem;
  cursor: pointer;
  margin-bottom: 0.5rem;
}
.MimaDropdown_singleTag__2cQTo > :not(:last-child) {
  margin-right: 0.5rem;
}
.MimaDropdown_singleTag__2cQTo:hover {
  color: var(--color-primary);
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/variables/_variables.scss","webpack://./src/assets/styles/MimaDropdown.module.scss"],"names":[],"mappings":"AAAA;EAEE,sBAAA;EACA,sBAAA;EACA,wBAAA;EAEA,wBAAA;EACA,0BAAA;EACA,0BAAA;EACA,0BAAA;EACA,0BAAA;EACA,0BAAA;EACA,2BAAA;EACA,2BAAA;EAEA,sBAAA;EACA,wBAAA;EACA,sBAAA;EACA,wBAAA;EACA,wBAAA;EACA,uBAAA;EACA,yBAAA;EACA,yBAAA;EACA,0BAAA;EACA,yBAAA;EAEA,qBAAA;EACA,uBAAA;EACA,uBAAA;EACA,uBAAA;EACA,uBAAA;EACA,uBAAA;EACA,uBAAA;EACA,uBAAA;EACA,2BAAA;EACA,6BAAA;EAIA,qBAAA;EAEA,uBAAA;EACA,uBAAA;EACA,uBAAA;EAEA,yBAAA;EACA,2BAAA;EACA,6BAAA;EACA,6BAAA;EAEA,4BAAA;EACA,4BAAA;EACA,4BAAA;EACA,6BAAA;EACA,0BAAA;EACA,2BAAA;EAEA,sBAAA;EACA,wBAAA;EACA,wBAAA;EAEA,6BAAA;EACA,+BAAA;EACA,+BAAA;EACA,+BAAA;EACA,2BAAA;EACA,6BAAA;EAEA,uBAAA;EACA,yBAAA;EAEA,2BAAA;EACA,6BAAA;EACA,6BAAA;EACA,6BAAA;EAEA,0BAAA;EAEA,gCAAA;EACA,kCAAA;EACA,kCAAA;EACA,kCAAA;EAGA,2BAAA;EACA,yBAAA;EACA,uBAAA;EACA,yBAAA;EACA,+BAAA;EACA,4BAAA;EACA,6BAAA;EAGA;;gCAAA;EAGA;wEAAA;EAEA;wEAAA;AClBF;;AA9EA;EACE,iBDsImB;ECrInB,oBAAA;EACA,kBAAA;EACA,mBAAA;EACA,WAAA;EACA,aAAA;EACA,gBAAA;AAiFF;AA/EE;EACE,iBD6HiB;EC5HjB,oBAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;AAiFJ;;AA7EA;EACE,aAAA;EACA,WAAA;EACA,sBAAA;EACA,gBAAA;EACA,cDsGW;ACtBb;AA9EE;EACE,oBAAA;EACA,eAAA;AAgFJ;AA9EI;EACE,mCAAA;EACA,yBAAA;AAgFN;AA7EI;EAEE,kBAAA;EACA,mBAAA;EAEA,YAAA;EACA,YAAA;EACA,mBAAA;EACA,oCAAA;EACA,yBAAA;EACA,cAAA;EACA,uBAAA;EACA,sBAAA;EACA,eAAA;EACA,cD6EO;EC5EP,kBAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;AA6EN;AA3EM;EACE,WAAA;EACA,mDAAA;EACA,wBAAA;EACA,4BAAA;EAEA,kBAAA;EACA,YAAA;EACA,aAAA;EACA,WAAA;EACA,WAAA;EAEA,oBAAA;AA2ER;AAxEM;EACE,kBAAA;EACA,WAAA;AA0ER;AAtEI;EACE,0BAAA;EACA,YAAA;AAwEN;AArEI;EACE,oCAAA;EACA,cD2CO;EC1CP,yBAAA;EACA,YAAA;EACA,mBAAA;EACA,oBAAA;EACA,QAAA;EACA,iBAAA;EACA,kBAAA;AAuEN;AArEM;EACE,WAAA;EACA,oCAAA;EACA,4BAAA;AAuER;AApEM;EACE,yBDqBK;ECpBL,mBAAA;AAsER;AAnEM;EACE,YAAA;AAqER;AAnEQ;EAHF;IAII,YAAA;EAsER;AACF;AAlEI;EACE,UAAA;EACA,iBAAA;EACA,kBAAA;AAoEN;AAjEI;EACE,eAAA;AAmEN;;AA9DA;EACE,aAAA;EACA,YAAA;EACA,sBAAA;EACA,gBAAA;EACA,cDHW;ACoEb;AA/DE;EACE,oBAAA;EACA,eAAA;AAiEJ;AA/DI;EACE,mCAAA;EACA,yBAAA;AAiEN;AA9DI;EAEE,kBAAA;EACA,mBAAA;EACA,oCAAA;EACA,YAAA;EACA,YAAA;EACA,mBAAA;EACA,oCAAA;EACA,yBAAA;EACA,cAAA;EACA,uBAAA;EACA,sBAAA;EACA,eAAA;EACA,cD5BO;EC6BP,kBAAA;EACA,QAAA;EACA,kBAAA;AA+DN;AA7DM;EACE,WAAA;EACA,mDAAA;EACA,wBAAA;EACA,4BAAA;EAEA,kBAAA;EACA,YAAA;EACA,aAAA;EACA,WAAA;EACA,WAAA;EAEA,oBAAA;AA6DR;AA1DM;EACE,kBAAA;EACA,WAAA;AA4DR;AAxDI;EACE,0BAAA;EACA,YAAA;AA0DN;AAvDI;EACE,oCAAA;EACA,cD7DO;EC8DP,yBAAA;EACA,YAAA;EACA,mBAAA;EACA,oBAAA;EACA,QAAA;EACA,iBAAA;EACA,kBAAA;EACA,oCAAA;AAyDN;AAvDM;EACE,WAAA;EACA,oCAAA;EACA,4BAAA;AAyDR;AAtDM;EACE,yBDpFK;ECqFL,mBAAA;AAwDR;AArDM;EACE,YAAA;AAuDR;AArDQ;EAHF;IAII,YAAA;EAwDR;AACF;AApDI;EACE,UAAA;EACA,iBAAA;EACA,kBAAA;AAsDN;AAnDI;EACE,eAAA;AAqDN;;AA9CA;EACE,cD1GW;AC2Jb;;AA9CA;EACE,oCAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;AAiDF;;AA5CE;EACE,2BAAA;EACA,iCAAA;EACA,gBAAA;EACA,mBAAA;AA+CJ;;AA3CA;EACE,aAAA;EACA,eAAA;AA8CF;AA5CE;EACE,kBAAA;AA8CJ;;AA1CA;EACE,aAAA;EACA,oCAAA;EACA,mBAAA;EACA,wCAAA;EACA,eAAA;EACA,qBAAA;EACA,eAAA;EACA,qBAAA;AA6CF;AA3CE;EACE,oBAAA;AA6CJ;AAzCE;EACE,2BAAA;AA2CJ","sourcesContent":[":root {\n  //COLORS\n  --color-light: #f4f9ff;\n  --color-white: #ffffff;\n  --color-white-2: #fbfcfe;\n\n  --color-primary: #1f68d6;\n  --color-primary-2: #3b7ee3;\n  --color-primary-3: #ccedff;\n  --color-primary-4: #003c97;\n  --color-primary-7: #c1daff;\n  --color-primary-8: #97c1ff;\n  --color-primary-09: #ccedff;\n  --color-mima-light: #eef2f5;\n\n  --color-error: #e12f2f;\n  --color-success: #66b032;\n  --color-green: #569755;\n  --color-green-2: #92e391;\n  --color-green-3: #d3eace;\n  --color-yellow: #e7d788;\n  --color-yellow-2: #ffaa00;\n  --color-yellow-3: #8f4f00;\n  --color-light-red: #f7d1cd;\n  --color-deep-red: #9f0000;\n\n  --color-grey: #b3b3c5;\n  --color-grey-2: #d1d1d1;\n  --color-grey-3: #e0e9f3;\n  --color-grey-4: #f9f9fa;\n  --color-grey-5: #ebebf5;\n  --color-grey-6: #eaecef;\n  --color-grey-7: #fafafa;\n  --color-grey-8: #707a8a;\n  --color-table-grey: #fafafc;\n  --color-table-grey-1: #f4f4fc;\n\n  // --color-dark: #4a4a68;\n  // --color-dark: #0C090D;\n  --color-dark: #252624;\n\n  --color-dark-2: #1a1a42;\n  --color-dark-3: #696365;\n  --color-dark-6: #2a2828;\n\n  --color-disabled: #c0c0c0;\n  --color-light-blue: #ebf2ff;\n  --color-light-blue-2: #d4e5ff;\n  --color-light-blue-3: #e7f3fe;\n\n  --color-dark-yellow: #7e6e1f;\n  --color-light-brown: #f4f5f6;\n  --color-light-green: #e4ffec;\n  --color-light-yellow: #fff5d7;\n  --color-light-red: #ffe8e8;\n  --color-light-grey: #f3f3ff;\n\n  --color-admin: #112855;\n  --color-admin-2: #071530;\n  --color-admin-3: #020710;\n\n  --color-fash-primary: #f5cc16;\n  --color-fash-primary-2: #c4a108;\n  --color-fash-primary-3: #927700;\n  --color-fash-primary-4: #f5e8b0;\n  --color-fash-black: #0c090d;\n  --color-fash-black-2: #312d33;\n\n  --color-purple: #6a3c8f;\n  --color-purple-1: #430d6e;\n\n  --color-fash-green: #cbebca;\n  --color-fash-green-1: #ebf2e9;\n  --color-fash-green-2: #035e00;\n  --color-fash-green-3: #023300;\n\n  --color-fash-wine: #824670;\n\n  --color-moneyex-primary: #25c900;\n  --color-moneyex-primary-2: #6bf04d;\n  --color-moneyex-primary-3: #305627;\n  --color-moneyex-primary-4: #0a2404;\n\n  // FONT SIZES\n  --default-font-size: 1.8rem;\n  --default-font-h1: 6.4rem;\n  --default-font-h2: 4rem;\n  --default-font-h3: 3.2rem;\n  --default-font-subtitle: 2.4rem;\n  --default-font-small: 1.4rem;\n  --default-font-xsmall: 1.2rem;\n\n  //FONT\n  --primary-font: \"Montserrat\", -apple-system, BlinkMacSystemFont, \"Segoe UI\",\n    \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Cantarell\", \"Fira Sans\", \"Droid Sans\",\n    \"Helvetica Neue\", sans-serif;\n  --secondary-font: \"Rowdies\", \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\",\n    \"Cantarell\", \"Fira Sans\", \"Droid Sans\", \"Helvetica Neue\", sans-serif;\n  --tertiary-font: \"Rubik\", \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\",\n    \"Cantarell\", \"Fira Sans\", \"Droid Sans\", \"Helvetica Neue\", sans-serif;\n}\n\n//COLORS\n$color-light: #f4f9ff;\n$color-white: #ffffff;\n$color-white-2: #fbfcfe;\n\n$color-primary: #1f68d6;\n$color-primary-2: #3b7ee3;\n$color-primary-3: #ccedff;\n$color-primary-4: #003c97;\n$color-primary-7: #c1daff;\n$color-primary-09: #ccedff;\n\n$color-error: #e12f2f;\n$color-success: #66b032;\n$color-green: #569755;\n$color-green-2: #92e391;\n$color-yellow: #e7d788;\n$color-light-red: #f7d1cd;\n\n$color-grey: #b3b3c5;\n$color-grey-2: #d1d1d1;\n$color-grey-3: #e0e9f3;\n$color-grey-4: #d1d1d1;\n$color-grey-6: #9898ab;\n\n$color-dark: #4a4a68;\n$color-dark-3: #696365;\n$color-dark-6: #2a2828;\n\n// FONT\n$default-font-size: 1.8rem;\n$default-font-h1: 6.4rem;\n$default-font-h2: 4rem;\n$default-font-h3: 3.2rem;\n$default-font-subtitle: 2.4rem;\n$default-font-small: 1.4rem;\n\n// SHADOWS\n$shadow-dark: 0 2rem 6rem rgba(0, 0, 0, 0.3);\n$shadow-light: 0 2rem 5rem rgba(0, 0, 0, 0.06);","@import \"./variables/variables\";\n\n.label {\n  font-size: $default-font-small;\n  font-family: inherit;\n  padding-left: 2rem;\n  margin-bottom: 1rem;\n  width: 100%;\n  display: flex;\n  max-width: 38rem;\n\n  &__wide {\n    font-size: $default-font-small;\n    font-family: inherit;\n    padding-left: 2rem;\n    margin-bottom: 1rem;\n    padding-left: 2rem;\n  }\n}\n\n.select {\n  display: flex;\n  width: 100%;\n  flex-direction: column;\n  margin-top: 3rem;\n  color: $color-dark;\n\n  &__options {\n    padding: 1.5rem 2rem;\n    cursor: pointer;\n\n    &:hover {\n      background-color: var(--color-dark);\n      color: var(--color-white);\n    }\n\n    &_selected {\n      // color: $color-grey;\n      padding-left: 2rem;\n      padding-top: 1.9rem;\n\n      width: 38rem;\n      height: 6rem;\n      border-radius: 1rem;\n      background-color: var(--color-white);\n      border: 1px solid $color-dark;\n      display: block;\n      justify-content: center;\n      box-sizing: border-box;\n      cursor: pointer;\n      color: $color-dark;\n      margin-top: 0.5rem;\n      margin-bottom: 1rem;\n      order: 0;\n      position: relative;\n\n      &::after {\n        content: \"\";\n        background: url(\"../svg/arrowDown.svg\");\n        background-size: contain;\n        background-repeat: no-repeat;\n\n        position: absolute;\n        height: 100%;\n        width: 1.6rem;\n        right: 2rem;\n        top: 2.5rem;\n\n        transition: all 0.4s;\n      }\n\n      &__wide {\n        padding-left: 2rem;\n        width: 100%;\n      }\n    }\n\n    &_active+&_selected::after {\n      transform: rotateX(180deg);\n      top: -2.5rem;\n    }\n\n    &_container {\n      background-color: var(--color-white);\n      color: $color-dark;\n      border: 1px solid $color-dark;\n      width: 38rem;\n      border-radius: 1rem;\n      transition: all 0.4s;\n      order: 1;\n      max-height: 27rem;\n      overflow-y: scroll;\n\n      &::-webkit-scrollbar {\n        width: 1rem;\n        background-color: var(--color-white);\n        border-radius: 0 1rem 1rem 0;\n      }\n\n      &::-webkit-scrollbar-thumb {\n        background-color: $color-grey;\n        border-radius: 1rem;\n      }\n\n      &__wide {\n        width: 60rem;\n\n        @media only screen and (max-width: 31.25em) {\n          width: 38rem;\n        }\n      }\n    }\n\n    &_active {\n      opacity: 1;\n      max-height: 27rem;\n      overflow-y: scroll;\n    }\n\n    &_label {\n      cursor: pointer;\n    }\n  }\n}\n\n.select2 {\n  display: flex;\n  width: 18rem;\n  flex-direction: column;\n  margin-top: 3rem;\n  color: $color-dark;\n\n  &__options {\n    padding: 1.5rem 2rem;\n    cursor: pointer;\n\n    &:hover {\n      background-color: var(--color-dark);\n      color: var(--color-white);\n    }\n\n    &_selected {\n      // color: $color-grey;\n      padding-left: 2rem;\n      padding-top: 0.9rem;\n      font-size: var(--default-font-small);\n      width: 18rem;\n      height: 4rem;\n      border-radius: 1rem;\n      background-color: var(--color-white);\n      border: 1px solid $color-dark;\n      display: block;\n      justify-content: center;\n      box-sizing: border-box;\n      cursor: pointer;\n      color: $color-dark;\n      margin-top: 0.5rem;\n      order: 0;\n      position: relative;\n\n      &::after {\n        content: \"\";\n        background: url(\"../svg/arrowDown.svg\");\n        background-size: contain;\n        background-repeat: no-repeat;\n\n        position: absolute;\n        height: 100%;\n        width: 1.6rem;\n        right: 2rem;\n        top: 1.5rem;\n\n        transition: all 0.4s;\n      }\n\n      &__wide {\n        padding-left: 2rem;\n        width: 100%;\n      }\n    }\n\n    &_active+&_selected::after {\n      transform: rotateX(180deg);\n      top: -2.5rem;\n    }\n\n    &_container {\n      background-color: var(--color-white);\n      color: $color-dark;\n      border: 1px solid $color-dark;\n      width: 18rem;\n      border-radius: 1rem;\n      transition: all 0.4s;\n      order: 1;\n      max-height: 27rem;\n      overflow-y: scroll;\n      font-size: var(--default-font-small);\n\n      &::-webkit-scrollbar {\n        width: 1rem;\n        background-color: var(--color-white);\n        border-radius: 0 1rem 1rem 0;\n      }\n\n      &::-webkit-scrollbar-thumb {\n        background-color: $color-grey;\n        border-radius: 1rem;\n      }\n\n      &__wide {\n        width: 38rem;\n\n        @media only screen and (max-width: 31.25em) {\n          width: 18rem;\n        }\n      }\n    }\n\n    &_active {\n      opacity: 1;\n      max-height: 27rem;\n      overflow-y: scroll;\n    }\n\n    &_label {\n      cursor: pointer;\n    }\n  }\n}\n\n// When form is filled\n\n.filled {\n  color: $color-dark;\n}\n\n.error {\n  font-size: var(--default-font-small);\n  color: var(--color-error);\n  padding-left: 2rem;\n  font-weight: 400;\n  margin: 1rem 0;\n  max-width: 38rem;\n}\n\n// Success\n.success {\n  &__h3 {\n    color: var(--color-success);\n    font-size: var(--default-font-h3);\n    font-weight: 700;\n    line-height: 3.5rem;\n  }\n}\n\n.tags {\n  display: flex;\n  flex-wrap: wrap;\n\n  &> :not(:last-child) {\n    margin-right: 1rem;\n  }\n}\n\n.singleTag {\n  display: flex;\n  font-size: var(--default-font-small);\n  align-items: center;\n  background-color: var(--color-primary-3);\n  padding: 0.5rem;\n  border-radius: 0.5rem;\n  cursor: pointer;\n  margin-bottom: 0.5rem;\n\n  &> :not(:last-child) {\n    margin-right: 0.5rem;\n  }\n\n\n  &:hover {\n    color: var(--color-primary);\n  }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"label": `MimaDropdown_label__Xurff`,
	"label__wide": `MimaDropdown_label__wide__72MNG`,
	"select": `MimaDropdown_select__dhfeg`,
	"select__options": `MimaDropdown_select__options__xLi7K`,
	"select__options_selected": `MimaDropdown_select__options_selected__1Ic9v`,
	"select__options_selected__wide": `MimaDropdown_select__options_selected__wide__uJhGk`,
	"select__options_active": `MimaDropdown_select__options_active__bNzTz`,
	"select__options_container": `MimaDropdown_select__options_container__KYLP5`,
	"select__options_container__wide": `MimaDropdown_select__options_container__wide__DveW-`,
	"select__options_label": `MimaDropdown_select__options_label__vZRRu`,
	"select2": `MimaDropdown_select2__WC+vJ`,
	"select2__options": `MimaDropdown_select2__options__QYoIu`,
	"select2__options_selected": `MimaDropdown_select2__options_selected__TI9ZR`,
	"select2__options_selected__wide": `MimaDropdown_select2__options_selected__wide__2eROH`,
	"select2__options_active": `MimaDropdown_select2__options_active__jr8lX`,
	"select2__options_container": `MimaDropdown_select2__options_container__qzUuM`,
	"select2__options_container__wide": `MimaDropdown_select2__options_container__wide__-+qxN`,
	"select2__options_label": `MimaDropdown_select2__options_label__7f+Pg`,
	"filled": `MimaDropdown_filled__9OL8h`,
	"error": `MimaDropdown_error__3x5pG`,
	"success__h3": `MimaDropdown_success__h3__HAymX`,
	"tags": `MimaDropdown_tags__yobUM`,
	"singleTag": `MimaDropdown_singleTag__2cQTo`
};
export default ___CSS_LOADER_EXPORT___;
